import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAdditionalProblems = createAsyncThunk("additionalProblem/question", async (data) => {
  try {
    const response = await axios.post(`/GetUserAdditionalProblems`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const submitAdditionalProblem = createAsyncThunk("additionalProblem/submitProblem", async (data) => {
  try {
    const response = await axios.post(`/SubmitAdditionalProblem`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});